export const stickyMenuBgColorChangeByScroll = (header, introService) => {
  const introServiceTop = introService?.offsetTop;

  window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY;

    if (scrollPosition >= introServiceTop) {
      header.classList.add('header-scrolled');
    }

    if (scrollPosition < introServiceTop) {
      header.classList.remove('header-scrolled');
    }
  });
};

export const infoService = () => {
  const tabs = document.querySelectorAll('.intro-service__tab');
  const contentBlocks = document.querySelectorAll('.intro-service__columns');

  const currentUrl = window.location.pathname;
  const currentLastPart = currentUrl.split('/').filter(Boolean).pop();

  tabs.forEach((tab) => {
    if (tab.classList.contains('intro-service__tab--link')) {
      const tabUrl = new URL(tab.href);
      const tabLastPart = tabUrl.pathname.split('/').filter(Boolean).pop();

      if (tabLastPart === currentLastPart) {
        tab.classList.add('active');
      }
    }

    // eslint-disable-next-line consistent-return
    tab.addEventListener('click', () => {
      const element = document.getElementById(tab.getAttribute('data-tab'));

      if (!element) {
        return false;
      }

      tabs.forEach((t) => t.classList.remove('active'));
      contentBlocks.forEach((content) => content.classList.remove('active'));

      tab.classList.add('active');

      if (element) {
        element.classList.add('active');
      }
    });
  });

  stickyMenuBgColorChangeByScroll();
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/intro-service', () => {
      infoService();
    });
  } else {
    infoService();
  }
});
